import { HStack } from '@chakra-ui/react';
import React from 'react';
import { Toaster } from '../ui/component/toaster/toaster.tsx';

export interface AppLayoutProps {
  children?: React.ReactNode;
}

/**
 * base layout for the entire app
 */
export default function AppLayout({ children }: AppLayoutProps) {
  return (
    <HStack minHeight={'100vh'} alignItems={'top'}>
      {/*Toaster Portal*/}
      <Toaster />
      {/*page content*/}
      {children}
    </HStack>
  );
}
